module.exports = __webpack_public_path__ + "c06bd7abaa2c419e0d86259fb7765f05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/email_delete_2x.png
// module id = 104
// module chunks = 0 1 2 3 4